import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { Location } from '@angular/common';
import * as _ from 'lodash';

import { NotificationModalComponent } from '../shared/component/notification-modal/notification-modal.component';
import { copyChecklist, copyQuestionGroup, generateVersion, generateVersionItems } from './utils';
import { ProceedModalComponent } from '../shared/component/proceed-modal/proceed-modal.component';
import { InstituteDepartamentService } from '../shared/service/institute-departament.service';
import { ChecklistInspectionModel } from '../shared/model/checklist-inspection.model';
import { InspectionPlanService } from '../shared/service/inspection-plan.service';
import { MessageComponent } from '../shared/component/message/message.component';
import { InspectionPlanModel } from '../shared/model/inspection-plan.model';
import { SignatureLevelsTranslation } from '../shared/enum/signature-level';
import { ConclusionTypesTranslation } from '../shared/enum/conclusion-type';
import { InspectableModalComponent } from './inspectable-modal/inspectable-modal.component';
import { InstituteDepartamentModel } from '../shared/model/institute-departaments.model';
import { ChecklistEndpointService } from '../shared/service/checklist-endpoint.service';
import { ChecklistEndpointModel } from '../shared/model/checklist-endpoint.model';
import { HeaderDefaultService } from '../shared/service/header-default.service';
import { QuestionGroupService } from '../shared/service/question-group.service';
import { HeaderItemService } from '../shared/service/header-item.service';
import { HeaderDefaultModel } from '../shared/model/header-default.model';
import { QuestionGroupModel } from '../shared/model/question-group.model';
import { ChecklistService } from '../shared/service/checklist.service';
import { HeaderItemModel } from '../shared/model/header-item.model';
import { ChecklistModel } from '../shared/model/checklist.model';
import { EmailService } from '../shared/service/email.service';
import { UserService } from '../shared/service/user.service';
import { EmailModel } from '../shared/model/email.model';

@Component({
	selector: 'app-checklist-form',
	templateUrl: './checklist-form.component.html',
	styles: [`.logo { width: 20%; max-height: 150px; }`]
})
export class ChecklistFormComponent implements OnInit {
	@ViewChild(MessageComponent) message: MessageComponent;
	@ViewChild(ProceedModalComponent) proceedModal: ProceedModalComponent
	@ViewChild(InspectableModalComponent) inspectableModal: InspectableModalComponent;
	@ViewChild(NotificationModalComponent) notificationModal: NotificationModalComponent;
	
	//null safe values
	checklist: ChecklistModel = new ChecklistModel();
	id: number = this.checklistService.getId();
	conclusionTypes: SelectItem[] = [];
	signatureLevels: SelectItem[] = [];
	menuIds = {};
	initialChecklist = {}
	initialLogo: any;
	loadingDots = '';

	//default values
	saveStatus: boolean = false;
	headerDefaultLoad = false;
	isEndpointEnabled = false;
	isInspectionPlan = false;
	headerItemsLoad = false;
	questionsLoad = false;
	entitiesLoad = false;
	emailsLoad = false;
	clicked = false;
	isCopy = false;
	open = false;
	files

	action: {
		callback?: Function;
		message?: string;
		title?: string;
		buttonLabel?: string;
	} = {}

	constructor(
		private router: Router, 
		private location: Location,
		private route: ActivatedRoute, 
		private userService: UserService,
		private emailService: EmailService, 
		private translateService: TranslateService,
		private checklistService: ChecklistService, 
		private headerItemService: HeaderItemService, 
		private endpointService: ChecklistEndpointService, 
		private headerDefaultService: HeaderDefaultService, 
		private questionGroupService: QuestionGroupService, 
		private inspectionPlanService: InspectionPlanService, 
		private instituteDepartamentService: InstituteDepartamentService, 
	) {
		this.updateFilterParams();
	}

	ngOnInit() {
		if (this.id) this.getChecklist(this.id);
		else this.open = true;

		this.buildDropDownOptions();
		this.canShowIntegrationButtons();
	}

  updateFilterParams() {
		this.id = parseInt(this.route.snapshot.paramMap.get("id")) || null;
		this.isCopy = this.route.snapshot.queryParamMap.get("isCopy") == 'true';
  }

	// usefull for multi logics
	canShowIntegrationButtons() {
		this.menuIds = {};

		const userToken = localStorage.getItem('loginToken');

		if (userToken && userToken.length)
		this.userService.getByToken(userToken).subscribe((user: {user_type: {menu_ids: string}}) => {
			if (!user || !user.user_type) return console.error('Invalid User');

			const { menu_ids } = user.user_type || { menu_ids: '' };
			const menuIds = JSON.parse(menu_ids);

			if (menuIds && menuIds.length) {
				menuIds.forEach((n) => {
					this.menuIds[n] = 1;
				})
			}
		});
	}

	saveEndpoint(endpoint: ChecklistEndpointModel) {
		if (!endpoint) return this.message.error('api_error_message');

		this.checklist.checklist_endpoint = endpoint;
		this.message.success('valid');
	}

	saveNotifications(event) {
		this.checklist.emails = event.emails;

		this.checklist.send_complete_email = event.sendCompleteEmailDep; // department
		this.checklist.send_unconformity_email = event.sendUnconformityEmailDep; // department
		this.checklist.send_complete_email_est = event.sendCompleteEmailEst; // establishment
		this.checklist.send_unconformity_email_est = event.sendUnconformityEmailEst; // establishment
		this.checklist.send_unconformity_email_only = event.sendUnconformityEmailOnly; // validation
	}

	onBackAction = () => {
		this.proceedModal.display = false
		this.router.navigate(['/checklist'])
	}

	onBackButtonPressed() {
		this.action = {
			callback: this.onBackAction,
			message: this.translate('lose_data_message'),
			buttonLabel: this.translate('confirm')
		}

		this.proceedModal.display = true
	}

	onNewChecklistAction = () => {
		this.proceedModal.display = false
		this.checklist = new ChecklistModel();
	}

	openNotificationModal() {
		this.notificationModal.onOpen();
	}

	delay = (ms: number) => new Promise(res => setTimeout(res, ms));

	newChecklist() {
		this.action = {
			callback: this.onNewChecklistAction,
			message: this.translate('lose_data_message'),
			buttonLabel: this.translate('confirm'),
		}
		this.proceedModal.display = true
	}

	updateQuestionGroup(question_groups) {
		this.checklist.question_groups = question_groups
	}

	canSave = () => !this.saveStatus && this.open && !this.clicked;

	onConfirmSaveWithoutEndpoint = () => {
		this.proceedModal.display = false;
		this.executeSaveChecklist();
	}

	saveChecklist() {
		if (this.isEndpointEnabled && !this.checklist.checklist_endpoint) {
			this.action = {
				message: this.translate('save_without_endpoint_message'),
				callback: this.onConfirmSaveWithoutEndpoint,
				buttonLabel: this.translate('confirm'),
			}

			this.proceedModal.display = true;
			return;
		}

		this.executeSaveChecklist();
	}

	private executeSaveChecklist() {
		if (!this.notificationModal.loadedMails && this.checklist.emails && this.checklist.emails.length) {
			return this.message.error(this.translate('confirm_email'));
		}

		if (!!this.isCopy)
			this.checklist = copyChecklist(this.checklist, !!this.isCopy)
		this.message.fixedInfo(this.translate('saving_checklist'));
		this.saveStatus = true;

		// Old method - Davi
		// let groupsWithWeight = this.checklist.question_groups.filter((item) => {
		// 	return item.questions.filter((question) => {
		// 		return (question.question_type == 4);
		// 	}).length > 0;
		// }), groupForWeight100Percent = null,
		// 	weightSum = groupsWithWeight.reduce((acc, crr) => {
		// 		acc += crr.weight
		// 		return acc
		// 	}, 0)

		// groups with qualified questions
		let groupsWithWeight = this.checklist.question_groups.filter((group) => {
			return group.questions.length && group.questions.some(
				// q.question_type == QuestionTypes['Avaliativa']
				(question) => question.weight > 0);
		}), weightSum = 0;

		// valid group weight sum
		let validGroups = groupsWithWeight.map((g) => g && g.weight).filter(v => v);

		// round the result to prevent calculation errors with broken values
		if (validGroups && validGroups.length) {
			weightSum = validGroups.reduce((n1, n2) => n1 + n2);
			weightSum = Math.round(weightSum * 100) / 100;
		}

		// for what?
		let groupForWeight100Percent = null;

		// calcInspectionPlanWeight
    const inspectionPlanWeightSum =
		this.checklist.inspection_plans &&
		this.checklist.inspection_plans.reduce(
			(t, ip) => t + (ip.weight || 0), 0
		) || 0;

		weightSum += (inspectionPlanWeightSum | 0);
		// end

		if ((weightSum > 0 && (weightSum < 100 || weightSum > 100))) {
			this.saveStatus = false;
			this.message.clear();

			return this.message.error(weightSum < 100 ? this.translate('group_contain_weight_message') : this.translate('group_exceeds_weight_limit_message'));
		}

		let message;
		if (groupsWithWeight.some((item) => {
			let questionSum = item.questions.reduce((acc, crr) => {
				acc += crr.weight
				return acc
			}, 0)

			questionSum = Math.round(questionSum * 1e2) / 1e2

			if (questionSum < 100) message = this.translate('questions_from_group') + item.name + this.translate('dont_complete_total_weight')
			if (questionSum > 100) message = this.translate('questions_from_group') + item.name + this.translate('exceeds_weight_limit')
			return questionSum > 0 && (questionSum < 100 || questionSum > 100)
		})) {
			this.saveStatus = false;
			this.message.clear();
			return this.message.error(message)
		}

		for (let questionGroup of this.checklist.question_groups) {
			if (!!questionGroup.id && questionGroup.id == groupForWeight100Percent) {
				questionGroup.weight = 100;
			}

			let questionWeightSum = questionGroup.questions.reduce((acc, crr) => {
				acc += crr.weight
				return acc
			}, 0)

			questionWeightSum = Math.round(questionWeightSum * 1e2) / 1e2

			if ((questionWeightSum > 0 && questionWeightSum < 100) && questionGroup.questions.length > 1) {
				this.saveStatus = false;
				this.message.clear();
				return this.message.error(this.translate('questions_from_group') + questionGroup.name + this.translate('dont_complete_total_weight'));
			}
		}

		this.checklistService.save({ ...generateVersion(this.checklist, this.isCopy) }).subscribe(result => {
			this.message.clear();

			this.saveHeader({ ...this.checklist, ...result }, result.id, result);
			if (result.previous_id) this.disableChecklist(this.checklist.previous_id);
		}, ({error}) => {
			this.saveStatus = false;
			this.message.clear();
		
			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);

			// return this.message.error(error.error.message);
		});
	}

	saveHeader(checklist: ChecklistModel, newChecklistId: number, checklist_created) {
		this.message.fixedInfo(this.translate('saving_headers'));
		this.headerItemService.saveInChecklist(checklist.header_items.map(({ checklist_id, id, previous_id, origin_id, ...otherProps }) => ({ ...generateVersionItems({ id, previous_id, origin_id }, this.isCopy), ...otherProps, checklist_id: newChecklistId })), newChecklistId).subscribe(result => {
			checklist_created.header_items = result === undefined || result === null ? [] : result;
			this.message.clear();
			this.checklist.header_items = result
			// console.log(result)
			this.saveHeaderDefault(checklist, newChecklistId, checklist_created, result);
		}, ({error}) => {

			this.saveStatus = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	saveHeaderDefault(checklist: ChecklistModel, newChecklistId: number, checklist_created, newHeaderItems) {
		this.message.fixedInfo(this.translate('saving_answered_headers'));
		
		let groupedByPreviousHeader = _.groupBy(newHeaderItems, 'previous_id'),
			newHeadersDefault = checklist.header_default.map(({ id, checklist_id, headerDefaultItems, ...otherProps }) => {
				return {
					id: 0, // fixed versioning
					checklist_id: newChecklistId,
					headerDefaultItems: headerDefaultItems.reduce((acc, { header_item_id, header_default_id, ...otherProps }) => {
						if (groupedByPreviousHeader[header_item_id]) {
							acc.push({
								header_item_id: groupedByPreviousHeader[header_item_id][0].id,
								...otherProps
							})
						}
						// return {
						// 	header_item_id: groupedByPreviousHeader[header_item_id][0].id,
						// 	...otherProps
						// }
						return acc
					}, []),
					...otherProps

				}
			})

		this.headerDefaultService.save(newHeadersDefault).subscribe(result => {
			checklist_created.header_default = result === undefined || result === null ? [] : result;
			this.message.clear();
			// console
			this.saveQuestions(checklist, newChecklistId, checklist_created);
		}, ({error}) => {
			this.saveStatus = false;
			this.message.clear();
		
			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	onSelect(e) {
		let newFiles = [];
		if (e.files)
			Array.from(e.files).forEach((item: Blob | any, i, arr) => {
				const reader = new FileReader();

				reader.readAsDataURL(item);
				reader.onload = () => {
					newFiles.push({
						base64: reader.result,
						type: item.type.length > 0 ? item.type : item.name.split('.').pop(),
						name: item.name,
						size: item.size,
					});
					// return res.result
					if (arr.length - 1 === i) this.files = newFiles;
					if (!this.initialLogo) this.initialLogo = this.checklist.logo
					this.checklist.logo = this.files[0]

					return;
				};

			});
		// this.files = e.files
	}

	onClear(event) {
		this.checklist.logo = this.initialLogo
		this.files = []
	}

	saveQuestions(checklist: ChecklistModel, newChecklistId: number, checklist_created) {
		this.message.fixedInfo(this.translate('saving_questions'));

		this.questionGroupService.saveInChecklist(checklist.question_groups.map(({ checklist_id, ...otherProps }) =>
			copyQuestionGroup({ ...otherProps, checklist_id: newChecklistId }, [], this.isCopy))
			, newChecklistId).subscribe(result => {
				checklist_created.question_groups = result === undefined || result === null ? [] : result;
				this.message.clear();
				this.saveInspectablesInChecklist(checklist, newChecklistId, checklist_created);
			}, ({error}) => {
				this.saveStatus = false;
				this.message.clear();

				const [errors, params] = 
				error && 
				error.message.includes(':') ? 
				error.message.split(':') : [error.message, '.'];

				return this.message.error(this.translate(errors) + params);
			});
	}

	saveChecklistEndpoint(checklist: ChecklistModel, newChecklistId: number, checklist_created) {
		this.message.fixedInfo(this.translate('saving_endpoint'));

		if (!this.checklist.checklist_endpoint || !this.checklist.checklist_endpoint.external_api) {
			return this.saveInspectionPlans(checklist, newChecklistId, checklist_created);
		}

		// set the new checklist_id and prepare the new entity for versioning
		this.checklist.checklist_endpoint.checklist_id = newChecklistId;
		this.checklist.checklist_endpoint.id = 0;

		this.endpointService.post(this.checklist.checklist_endpoint).subscribe(_ => {
			this.message.clear();
			this.saveInspectionPlans(checklist, newChecklistId, checklist_created);
		}, ({error}) => {
			this.message.clear();
			this.saveStatus = false;

			const [errors, params] = error && 
			error.message && error.message.includes(':') ? 
			error.message.split(':') : [error.message || error, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	saveInspectablesInChecklist(checklist: ChecklistModel, newChecklistId: number, checklist_created) {
		this.message.fixedInfo(this.translate('saving_inspectables'));
		this.instituteDepartamentService.saveInspectablesInChecklist(checklist.institute_departaments, newChecklistId).subscribe(result => {
			checklist_created.institute_departaments = result === undefined || result === null ? [] : result;
			this.message.clear();

			this.saveChecklistEndpoint(checklist, newChecklistId, checklist_created);
			//this.saveInspectionPlans(checklist, newChecklistId, checklist_created);
			//this.saveMail(checklist, newChecklistId, checklist_created);
		}, ({error}) => {
			this.saveStatus = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	saveInspectionPlans(checklist: ChecklistModel, newChecklistId: number, checklist_created) {
		this.message.fixedInfo(this.translate('saving_inspection_plans'));

		if (!this.checklist.inspection_plans || !this.checklist.inspection_plans.length) {
			return this.saveMail(checklist, newChecklistId, checklist_created);
		}

		let insPlanUnconformities = [];

		// mapping for save on api
		this.checklist.inspection_plans = this.checklist.inspection_plans.map(ip => {
			const mapped = new ChecklistInspectionModel({
				checklist_id: newChecklistId,
				inspection_plan_id: ip.id,
				keep_status: ip.keep_status || 0,
				verify: ip.verify || 0,
				weight: ip.weight || 0,
			} as any);

			mapped.unconformities = ip.unconformities ? ip.unconformities.map(unc => {
				unc.checklist_id = newChecklistId;
				unc.inspection_plan_id = ip.id;
				unc.unconformity_id = unc.id;
				return unc;
			}).filter(m => m) : [];

			// removed to optimize request
			delete mapped.inspection_plan;

			return mapped as any;
		});

		this.inspectionPlanService.withUnconformities(this.checklist.inspection_plans).subscribe(result => {
			this.message.clear();

			this.saveMail(checklist, newChecklistId, checklist_created);
		}, ({error}) => {
			this.saveStatus = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	saveMail(checklist: ChecklistModel, newChecklistId: number, checklist_created: ChecklistModel) {
		this.message.fixedInfo(this.translate('saving_emails'));

		this.emailService.saveEmailsInChecklist(checklist.emails, newChecklistId).subscribe(result => {
			checklist_created.emails = result === undefined || result === null ? [] : result;

			this.checklist = checklist_created as ChecklistModel;
			this.id = newChecklistId;

			this.clicked = true;

			if (checklist_created.previous_id)
			this.disableChecklist(this.checklist.previous_id);

			this.getChecklist(checklist_created.id);
			this.backPage();
			
			this.message.clear();

			this.saveStatus = false;

			return this.message.success("success_save_message_checklist", 4000);
		}, ({error}) => {
			this.saveStatus = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	backPage() {
		const currentUrl = this.router.url;

		setTimeout(() => {
			if (this.router.url == currentUrl) {
				this.location.back();
			}
		}, 2000);
	}

	disableChecklist(idDisable) {
		this.checklistService.disableCheckList(idDisable).subscribe((item) => {

		})
	}

	saveHeaderItems(e: HeaderItemModel[]) {
		this.checklist.header_items = e;
	}

	saveInspectables(e: InstituteDepartamentModel[]) {
		this.checklist.institute_departaments = e;
	}

	openInspectablesModal() {
		this.inspectableModal.display = true;
	}

	updateInspectionPlans(inspections: InspectionPlanModel[]) {
		this.checklist.checklist_inspections = null;

		if (inspections && inspections.length) {
			this.checklist.inspection_plans = inspections;
		}
	}

	buildDropDownOptions() {
		let types: number[] = [];
		let levels: number[] = [];

		for (let type in ConclusionTypesTranslation) {
			if (!isNaN(parseInt(type))) {
				types.push(parseInt(type));
			}
		}

		for (let level in SignatureLevelsTranslation) {
			if (!isNaN(parseInt(level))) {
				levels.push(parseInt(level));
			}
		}

		this.translateService.get('translate_version').subscribe(_ => {
			types.forEach(value => {
				const realName = ConclusionTypesTranslation[value];
				const label = this.translate(realName);

				this.conclusionTypes.push({
					label, value, 
				});
			});

			levels.forEach(value => {
				const realName = SignatureLevelsTranslation[value];
				const label = this.translate(realName);

				this.signatureLevels.push({ label, value });
			});
		})

		// levels.forEach(level => {
		// 	this.signatureLevels.push({ label: SignatureLevels[level], value: level });
		// });
	}

	getBase64(base64): string {
		if (base64.includes('data:image/png;base64,')) return base64
		return `data:image/png;base64,${base64}`
	}

	getChecklist(id: number, updateOlder?: boolean) {
		this.animationLoad();
		this.checklistService.findBaseInfoById(id).subscribe(record => {
			const { id: recordId, name, version, ...otherProps } = record

			this.isEndpointEnabled = record.checklist_endpoint && record.checklist_endpoint.id;
			this.isInspectionPlan = record.checklist_inspections && record.checklist_inspections.length > 0;

			this.checklist = { ...!!this.isCopy ? { name: name + ' ' + this.translate('copy') } : { id: recordId, name, version }, ...otherProps } as ChecklistModel;

			this.loadHeaderItems(this.id);
			this.loadInspections();
		}, ({error}) => {
			this.entitiesLoad = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	exportChecklist() {
		let { id, origin_id, previous_id, ...otherChecklistProps }:any = this.checklist
		otherChecklistProps.header_default = []
		otherChecklistProps.header_items = otherChecklistProps.header_items.map(({id, previous_id, origin_id, ...otherProps}) => ({...otherProps}))
		otherChecklistProps.question_groups = otherChecklistProps.question_groups.map(({id, previous_id, origin_id, questions, checklist_id, ...otherProps}) => {
			return {
				questions: questions.map(({id, origin_id, previous_id, ...otherQuestProps}) => ({...otherQuestProps})),
				...otherProps
			}
		})
		const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(otherChecklistProps)),
			downloadAnchorNode = document.createElement('a');
		downloadAnchorNode.setAttribute("href", dataStr);
		downloadAnchorNode.setAttribute("download", `${this.checklist.name}.json`);
		document.body.appendChild(downloadAnchorNode); // required for firefox
		downloadAnchorNode.click();
		downloadAnchorNode.remove();
	}

	importChecklist() {
		let input = document.createElement('input')
		input.type = 'file'
		input.multiple = false
		input.accept = ".json,application/json"
		input.onchange = (e: any) => {
			let reader = new FileReader();
			reader.onload = (event: any) => {
				this.checklist = JSON.parse(event.target.result)
			};
			reader.readAsText(e.currentTarget.files[0]);
		}
		input.click()
	}

	// need be refactored yet ;-;
	// refactored to use old code
	loadInspections() {
		this.checklist.inspection_plans = [];

		if (this.id && this.checklist.checklist_inspections && this.checklist.checklist_inspections.length) {
			this.checklist.inspection_plans = this.checklist.checklist_inspections.map(ci => {
				const ipm = new InspectionPlanModel();

				ipm.inspection_plan_items = ci.inspection_plan.inspection_plan_items;
				ipm.description = ci.inspection_plan.description;
				ipm.unconformities = ci.unconformities;
				ipm.name = ci.inspection_plan.name;
				ipm.id = ci.inspection_plan_id;
				ipm.keep_status = ci.keep_status;
				ipm.verify = ci.verify;
				ipm.weight = ci.weight;

				return ipm;
			}) as InspectionPlanModel[];
		}
	}

	loadHeaderItems(id: number) {
		this.headerItemsLoad = true;
		this.headerItemService.findByChecklistId(id).subscribe(record => {
			if (record.length > 0)
				this.checklist.header_items = record.map((item) => {
					let { checklist_id, id: itemId, ...otherProps } = item
					return { ...!!this.isCopy ? {} : { checklist_id, id: itemId }, ...otherProps }
				}) as HeaderItemModel[];
			else
				this.checklist.header_items = [];
			this.headerItemsLoad = false;
			this.loadHeaderDefaultItems(id);
		}, ({error}) => {
			this.headerItemsLoad = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	loadHeaderDefaultItems(id: number) {
		this.headerDefaultLoad = true;

		this.headerDefaultService.findByChecklistId(id).subscribe(record => {

			if (record.length > 0)
				this.checklist.header_default = record.map((item) => {
					let { checklist_id, ...otherProps } = item
					return { ...!!this.isCopy ? {} : { checklist_id }, ...otherProps }
				}) as HeaderDefaultModel[];
			else
				this.checklist.header_default = [];
			this.headerDefaultLoad = false;
			this.loadQuestions(id);
		}, ({error}) => {
			this.headerDefaultLoad = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	loadQuestions(id: number) {
		this.questionsLoad = true;

		this.questionGroupService.findByChecklistId(id).subscribe(record => {
			if (record.length > 0) {
				this.checklist.question_groups = _.orderBy(record.map((item) => {
					let { checklist_id, id: itemId, questions, ...otherProps } = item
					return { ...!!this.isCopy ? {name: + this.translate('translate_version')} : { checklist_id, id: itemId }, ...otherProps, questions: _.orderBy(questions, 'item_order') }
				}) as QuestionGroupModel[], 'item_order')

			}
			else
				this.checklist.question_groups = [];

			this.questionsLoad = false;
			this.loadEntities(id);
		}, ({error}) => {
			this.questionsLoad = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	loadEntities(id: number) {
		this.entitiesLoad = true;

		this.instituteDepartamentService.findByChecklistId(id).subscribe(record => {
			if (record.length > 0)
				this.checklist.institute_departaments = record.map((item) => {
					let { checklist_id, checklists, ...otherProps } = item
					return { ...!!this.isCopy ? {} : { checklist_id, checklists }, ...otherProps }
				}) as InstituteDepartamentModel[];
			else
				this.checklist.institute_departaments = [];

			this.entitiesLoad = false;
			this.loadEmails(id);
		}, ({error}) => {
			this.entitiesLoad = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			return this.message.error(this.translate(errors) + params);
		});
	}

	loadEmails(id: number) {
		this.emailsLoad = true;

		this.emailService.findByChecklistId(id).subscribe(record => {
			if (record.length > 0)
				this.checklist.emails = record.map((item) => {
					let { checklist_id, ...otherProps } = item
					return { ...!!this.isCopy ? {} : { checklist_id }, ...otherProps }
				}) as EmailModel[];
			else
				this.checklist.emails = [];
			if (!this.isCopy)
				this.initialChecklist = this.checklist
			this.emailsLoad = false;
			
			this.open = true;
		}, ({error}) => {
			this.emailsLoad = false;
			this.message.clear();

			const [errors, params] = 
			error && 
			error.message.includes(':') ? 
			error.message.split(':') : [error.message, '.'];

			this.open = true;

			return this.message.error(this.translate(errors) + params);
		});
	}

	animationLoad() {
		if (this.headerItemsLoad || this.headerDefaultLoad || this.questionsLoad || this.entitiesLoad || this.emailsLoad) {
			setTimeout(() => {
				let sizeLoading = this.loadingDots.length;
				this.loadingDots = sizeLoading === 0 ? '.' : (sizeLoading === 1 ? '..' : (sizeLoading === 2 ? '...' : ''));
				this.animationLoad();
			}, 250);
		}
	}

	translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();

}

// Legado

// this.signatureLevels.push({
// 	label: 'Selecione um nível de assinatura',
// 	value: null
// });
// this.conclusionTypes.push({
// 	label: this.translate("select_conclusion_type"),
// 	value: null
// });



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/checklist-form.component.ts